import { AVATAR_LIST } from '@assets/avatar/avatar';
import { icons } from '@icons/icons.js';

export const ASSETS = {
    avatars: AVATAR_LIST,
    icons: icons,
};